var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{attrs:{"src":_vm.urls[0],"fit":"contain","preview-src-list":_vm.urls}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])}
var staticRenderFns = []

export { render, staticRenderFns }